module.exports = __webpack_public_path__ + "img/db_helvethaica_x_li_v3.2-webfont.f8025ad9.svg";